import createContext from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import type { ClassTypeResponse } from 'tm3-core/api.dtos';

// Create Context
export const [ClassTypeStoreCtx, useClassTypeStore] =
  createContext<ClassTypeStore>('ClassTypeStore');

// Filter Type Definition
export type ClassFilterType = 'all' | 'class' | 'course';

// ClassTypeStore Implementation
export default class ClassTypeStore extends CacheStore<ClassTypeResponse> {
  constructor() {
    super('classTypes');
  }

  public search(searchTerm: string = '', filterType: ClassFilterType = 'all'): ClassTypeResponse[] {
    const trimmedSearchTerm = searchTerm.trim();
    if (!trimmedSearchTerm) return []; // Return early if searchTerm is empty or whitespace

    const lowerSearchTerm = trimmedSearchTerm.toLowerCase();
    debugger;
    return this.All.filter((classType) => {
      const matchesType =
        filterType === 'all' ||
        (filterType === 'class' && !classType.isCourse) ||
        (filterType === 'course' && classType.isCourse);

      const matchesSearchTerm =
        (classType.name ?? '').toLowerCase().includes(lowerSearchTerm) ||
        (classType.description ?? '').toLowerCase().includes(lowerSearchTerm);

      return matchesType && matchesSearchTerm; // Combine conditions
    });
  }
}
